import React, { CSSProperties } from 'react';

export interface SalariesSummeryItemDatamodel {
  text: string;
  value: string;
  valueStyle?: CSSProperties;
  textStyle?: CSSProperties;
  rootStyle?: CSSProperties;
}

export const SalariesColumnSummeryItem: React.FC<
  SalariesSummeryItemDatamodel
> = ({ text, value, valueStyle, textStyle, rootStyle }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        ...rootStyle,
      }}
    >
      <label style={{ fontWeight: 'initial' }}>{text}</label>
      <label style={{ ...valueStyle }}>{value}</label>
    </div>
  );
};
